class Header {
  constructor(el, opt) {
    this.el = '.' + el;
    this.$el = $(this.el);
    this.threshold = (opt && opt.threshold) || 500;
    this.compactClass = 'is-compact';
    this.pcQuery = window.matchMedia('(min-width: 768px)');

    if (this.$el.length > 0) {
      this.event();
    }
  }

  event() {
    const update = () => {
      const shouldCompact = this.pcQuery.matches && window.scrollY >= this.threshold;

      this.$el.toggleClass(this.compactClass, shouldCompact);
    };

    $(window).on('scroll', update);
    $(window).on('resize', update);
    update();
  }
}
